// bao migrate skip
// bao migrate - module not found: import ISubProjectQualificationModel from "view-models/dialogs/isub-project-qualification-model";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-number-box";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";

class SubProjectQualificationDialog implements ISubProjectQualificationDialog {
    Dialog: BaoDialog = new BaoDialog(Bao.Session.ApplicationName);
    DialogResult: KnockoutObservable<boolean> = this.Dialog.DialogResult;
    SessionTabId: string;
    CustomerId: KnockoutObservable<string> = ko.observable(null);
    ProjectId: string;
    SubProjectId: string;
    ConfigurationItem250QualificationId: string;
    constructor(sessionTabId: string, customerId: string, projectId: string, subProjectId: string, configurationItem250QualificationId: string) {
        this.Dialog.Width("600px");
        this.Dialog.Buttons([
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgOk"), $.proxy(this.OkClick, this)),
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgCancel"), $.proxy(this.CancelClick, this))
        ]);
        this.SessionTabId = sessionTabId;
        this.CustomerId(customerId);
        this.ProjectId = projectId;
        this.SubProjectId = subProjectId;
        this.ConfigurationItem250QualificationId = configurationItem250QualificationId;
    }
    Open() {
        var self = this;
        self.Dialog.IsLoading(true);
        Bao.post("ConfigurationItemTab/ShowConfigurationItemSubprojectQualificationDialog", JSON.stringify({
            sessionTabId: self.SessionTabId,
            parentConfigurationItemId: self.ProjectId,
            configurationItemId: self.SubProjectId,
            configurationItem250QualificationId: self.ConfigurationItem250QualificationId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().Focus = function () { };
            self.Dialog.ViewModel().FilterId = ko.observable();
            self.Dialog.ViewModel().FilterId(self.CustomerId());
            self.Dialog.ViewModel().QualificationId.subscribe(function (qualificationId) {
                self.LoadDefaultHourlyRate(qualificationId, self.CustomerId());
            });
            self.Dialog.Template(value.Message);
            self.Dialog.IsLoading(false);
            self.Dialog.Open(null);
            self.Dialog.ViewModel().Focus();
        });
    }
    LoadDefaultHourlyRate(qualificationId, customerId): JQueryPromise<number> {
        var self = this;
        this.Dialog.IsLoading(true);
        var def = $.Deferred<number>();
        Bao.post("Qualification/LoadDefaultHourlyRate", JSON.stringify({
            qualificationId: qualificationId,
            customerId: customerId
        }), function (result) {
            def.resolve(result);
            self.Dialog.ViewModel().HourlyRate(result);
            self.Dialog.IsLoading(false);
        });
        return def.promise();
    }
    OkClick(): void {
        if (this.CompleteCheck() == true) {
            this.AddQualification(this.Dialog.ViewModel()).then(() => {
                this.DialogResult(true);
                this.Dialog.Close();
            });
        }
    }
    AddQualification(model: ISubProjectQualificationModel): JQueryPromise<void> {
        var self = this;
        this.Dialog.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemSubprojectQualification", JSON.stringify({
            sessionTabId: self.SessionTabId,
            parentConfigurationItemId: self.ProjectId,
            configurationItemId: self.SubProjectId,
            qualificationModel: ko.map.toJS(model)
        }));
    }
    ;
    CancelClick(): void {
        this.DialogResult(false);
        this.Dialog.Close();
    }
    CompleteCheck(): boolean {
        var isComplete: boolean = true;
        if (this.Dialog.ViewModel().QualificationId() == null) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
}
export default SubProjectQualificationDialog;

export interface ISubProjectQualificationDialogStatic {
    new (sessionTabId: string, customerId: string, projectId: string, subProjectId: string, configurationItem250QualificationId: string): ISubProjectQualificationDialog;
}

export interface ISubProjectQualificationDialog {
    Dialog: BaoDialog;
    DialogResult: KnockoutObservable<boolean>;

    SessionTabId: string;
    CustomerId: KnockoutObservable<string>;
    ProjectId: string;
    SubProjectId: string;
    ConfigurationItem250QualificationId: string;

    Open: () => void;
    OkClick: () => void;
    CancelClick: () => void;
}

export interface ISubProjectQualificationModel {
    ConfigurationItem250QualificationId: KnockoutObservable<string>;
    ConfigurationItemId: KnockoutObservable<string>;
    QualificationId: KnockoutObservable<string>;
    QualificationName: KnockoutObservable<string>;
    ResourceModelsFiltered: KnockoutObservableArray<any>;
    HourlyRate: KnockoutObservable<number>;
}